import { Button, Drawer, TextField } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import React, { useReducer, useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { HostingPreferences } from '../../../constants/HostingPreferences';
import CustomSelect from '../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import AddEditLanguages from '../../add-edit-languages/Add-Edit-Languages';
import { ServerConfiguartions } from '../../../constants/ServerConfigurations';
import { formDataValidate } from '../../../utils/formUtils';
import { saveOrUpdateGlobalDefaultConfigs } from '../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../utils/NotificationUtils';
import {
  fetchAllGREGlobalConfigs,
  greGlobalDefaultTabSelector,
} from '../../../layouts/configurations/configurationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../utils/loaderSlice';

const GuestRoomExperienceGlobalTabDefault = (props) => {
  const { selectedHotel, showLoader = () => {} } = props;
  const [lstHostingPreference, setHostingPreference] = useState([]);
  const [lstServerConfigs, setServerConfigs] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const dispatch = useDispatch();
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    hostingPref: {
      value: '',
      fieldName: 'Select a hosting preference',
      errors: {},
      validations: [],
    },
    id: {
      value: '',
      fieldName: 'ID Format',
      errors: {},
      validations: ['required'],
    },
    serverConfigType: {
      value: '',
      fieldName: 'Select a Server configuration',
      errors: {},
      validations: ['required'],
    },
  });
  const [state, setState] = useState({ status: false, obj: [] });
  const data = useSelector(greGlobalDefaultTabSelector);

  useEffect(() => {
    if (data) {
      const currFields = { ...formData };
      setIsTabInValid(false);
      for (let field in data) {
        if (field === 'languages' && data['languages']) {
          setSelectedLanguages(
            data[field].map((item, index) => {
              return {
                index: item.index,
                code: item.languageCode,
                name: item.languageName,
              };
            }),
          );
        } else if (currFields.hasOwnProperty(field)) {
          currFields[field].value = data[field];
        }
      }
    }
  }, [data]);

  useEffect(() => {
    if (!lstHostingPreference.length) {
      setHostingPreference(HostingPreferences);
    }
  }, [lstHostingPreference]);

  useEffect(() => {
    if (!lstServerConfigs.length) {
      setServerConfigs(ServerConfiguartions);
    }
  }, [lstServerConfigs]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        dispatch(stepUpLoaderCount());
        const payload = {};

        for (let field in formData) {
          payload[field] = formData[field].value;
        }

        payload['languages'] = selectedLanguages.map((item) => {
          return { languageName: item.name, languageCode: item.code };
        });

        await saveOrUpdateGlobalDefaultConfigs(selectedHotel, payload);
        notificationManager('success', 'Default details added successfully');
        dispatch(fetchAllGREGlobalConfigs(selectedHotel));
      } catch (error) {
        if (error?.message) {
          notificationManager('danger', error?.message);
        } else {
          notificationManager('danger', 'Default details save failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onAddEditClick = () => {
    setState({ status: true, obj: selectedLanguages });
  };

  const onDrawerToggle = (status, obj) => {
    setState({ status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const onAddEditLanguageChange = (languages) => {
    setSelectedLanguages(languages);
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(Object.entries(formData));
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        <AddEditLanguages
          languages={state.obj}
          toggleDrawer={onDrawerToggle}
          addEditChange={onAddEditLanguageChange}
          showLoader={showLoader}
        />
      </Drawer>
      <form className='global-tab' noValidate onSubmit={handleSubmit}>
        <div className='container px-0 d-flex align-items-end flex-column h-100'>
          <div className='row w-100 d-flex mt-2'>
            <div className='row col-12 flex-wrap'>
              <div className='col-12 col-lg-5 mb-3'>
                <CustomSelect
                  valueField='id'
                  labelField='name'
                  item={formData.hostingPref}
                  handleInputChange={(e) => {
                    setFormData({ hostingPref: e });
                  }}
                  options={lstHostingPreference}
                />
              </div>
              <div className='col-11 col-lg-5 mb-3'>
                <CustomTextField
                  item={formData.id}
                  handleInputChange={(e) => {
                    setFormData({ id: e });
                  }}
                />
              </div>
              <div className='col'>
                <ReactTooltip html={true} />
                <span data-tip='(ID Format : Hotel Name +<br /> Room Type + Room No)'>
                  <Info className='svg_icons_info' />
                </span>
              </div>
            </div>
            <div className='row'>
              <div className='col-12 col-lg-5 mb-3'>
                <CustomSelect
                  valueField='id'
                  labelField='name'
                  item={formData.serverConfigType}
                  handleInputChange={(e) => {
                    setFormData({ serverConfigType: e });
                  }}
                  options={lstServerConfigs}
                  hideNullOption
                />
              </div>
            </div>
            <div className='row pt-3'>
              <div className='col-md-8 ps-3 px-0'>
                {selectedLanguages.map((language, key) => (
                  <div className='row w-100 mb-3 me-0' key={key}>
                    <div className='col-md-6'>
                      <TextField
                        className='col-md-12 pe-0'
                        id='language-name-field'
                        value={language.name}
                        label={'Language Name - ' + (key + 1)}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </div>
                    <div className='col-md-6 pe-0'>
                      <TextField
                        className='col-md-12'
                        id='language-code-field'
                        value={language.code}
                        label='Language Code'
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div className='col-md-4 mb-3 d-flex justify-content-end align-items-start'>
                <Button
                  className='underlined'
                  variant='text'
                  onClick={(e) => {
                    onAddEditClick();
                  }}
                >
                  Edit/Add Languages <ModeEditIcon className='ms-2' fontSize='small' />
                </Button>
              </div>
            </div>
          </div>
          <div className='row d-flex mt-auto w-100 pb-4'>
            <div>
              <Button
                size='large'
                variant='contained'
                color='primary'
                className='me-3'
                type='submit'
                disabled={isTabInValid}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default GuestRoomExperienceGlobalTabDefault;
